import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCSS } from '@pu/mpp-ui/hooks';
import { useAuth } from 'core/hooks/auth/use-auth.hooks';
import { Header } from 'shared/components/header';
import { SideNav } from 'shared/components/side-nav';

import './main-layout.scss';

export interface IMainLayoutProps {
  children: React.ReactNode;
  maxWidthEnabled?: boolean;
}

export const MainLayout = ({ children, maxWidthEnabled = false }: IMainLayoutProps) => {
  const css = useCSS('main-layout');
  const { pathname } = useLocation();
  const { name, username } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toogleSidebar = () => setSidebarOpen(!sidebarOpen);

  const userFullName = name || username;
  const closed = !sidebarOpen;

  return (
    <div className={css()}>
      <Header onButtonClick={toogleSidebar} buttonClicked={sidebarOpen} userFullName={userFullName} />
      <div className={css('container')}>
        <aside className={css('sidebar', { closed })}>
          <SideNav currentPath={pathname} />
        </aside>
        <main className={css('content-wrapper')}>
          <div className={css('content', { 'max-content': maxWidthEnabled })}>{children}</div>
        </main>
      </div>
    </div>
  );
};
